import {combineReducers} from 'redux'
import createReducer from 'admin/reducers/createReducer'

const INITIAL_ADMIN_STATE = {}
export default createReducer(INITIAL_ADMIN_STATE, {})
